// src/data/data.js
import { FaUniversity, FaBuilding } from "react-icons/fa";
import bscCS from "../assets/bsc_cs.png";
import mscCS from "../assets/msc_cs.png";
import mscFinance from "../assets/msc_finance.png";
import tinotendaCertificate from "../assets/tinotenda_certificate.png";
import kelley from "../assets/kelley.png";
import discover from "../assets/discover.png";
import ttcs from "../assets/ttcs.png";
import u_nicosia from "../assets/u_nicosia.png";
import catalink from "../assets/catalink.png";
import food from "../assets/tech-icons/gemini_health_app.jpg";
import youtube from "../assets/tech-icons/youtube_blog_creator.jpg";
import youtube2 from "../assets/tech-icons/youtube2.jpg";
import qa from "../assets/tech-icons/QA.jpg";
import chat from "../assets/tech-icons/chat.png";
import comp from "../assets/tech-icons/COMP1.jpg";
import invoice from "../assets/tech-icons/Invoice.png";
import sql from "../assets/tech-icons/sql_logo.jpeg";
import resume from "../assets/tech-icons/resume.jpg";
import document from "../assets/tech-icons/document.jpg";
import text from "../assets/tech-icons/Text_Summary.jpg";
import nvidianim from "../assets/tech-icons/nvidia.png";
import graph from "../assets/tech-icons/graph.png";
import query from "../assets/tech-icons/query.png";
import finetuning from "../assets/tech-icons/finetuning.png";
import ethereum from "../assets/tech-icons/ethereum.jpg";
import deepfake from "../assets/tech-icons/DeepFake.png";
import emotion from "../assets/tech-icons/emotion.png";
import brain from "../assets/tech-icons/brain.jpg";
import covid19 from "../assets/tech-icons/covid19.png";
import agegender from "../assets/tech-icons/ageandgender.jpg";
import numberPlate from "../assets/tech-icons/NumberPlate.jpg";
import language from "../assets/tech-icons/language.jpg";
import stress from "../assets/tech-icons/stress.png";
import weed from "../assets/tech-icons/weed.png";
import renewable from "../assets/tech-icons/renewableenergy.png";
import dna from "../assets/tech-icons/dna.png";
import diamond from "../assets/tech-icons/diamond.jpg";
import spell from "../assets/tech-icons/spellcheck.png";
import education from "../assets/tech-icons/education.png";
import car from "../assets/tech-icons/car.jpg";
import { CgArrowAlignH } from "react-icons/cg";
import books from "../assets/tech-icons/books.jpg";
import course from "../assets/tech-icons/course.png";
import songs from "../assets/tech-icons/songs.jpg";
import medical from "../assets/tech-icons/Medical.jpg";
import networksecurity from "../assets/tech-icons/networksecurity.jpg";
import finitedifferences from "../assets/tech-icons/finite_differences.png";
import newton from "../assets/tech-icons/Newton_Raphson.png";
import newtonmethod from "../assets/tech-icons/newtonmethod.jpg";
import simpleiterations from "../assets/tech-icons/simpleiterations.jpg";
import bisectionmethod from "../assets/tech-icons/bisection.png";
import gaussian from "../assets/tech-icons/Gaussian.png";
import trapezoidal from "../assets/tech-icons/trapezoidal_rule.jpg";
// Tech Stack Icons
export const techIcons = {
  Streamlit: "../assets/tech-icons/streamlit.png",
  "Google GenAI": "../assets/tech-icons/google-genai.png",
  Python: "../assets/tech-icons/python.png",
  PIL: "../assets/tech-icons/pil.png",
};

export const educationData = [
  {
    institution: "Kelley School of Business, Indiana University",
    degree: "Master of Science in Finance, Financial Technology",
    date: "May 2023",
    details: [,],
    icon: <img src={kelley} alt="Kelley School" className="h-12 w-12" />,
  },
  {
    institution: "University of Nicosia",
    degree: "Master of Science in Computer Science, Mobile Systems",
    date: "May 2022 - GPA: 3.92/4.00",
    details: ["◦ Appeared on the Dean's list for the whole program"],
    icon: <img src={u_nicosia} alt="UNIC" className="h-12 w-12" />,
  },
  {
    institution: "University of Nicosia",
    degree: "Master of Science in Computer Science, Minor in Mathematics",
    date: "May 2020",
    details: [
      "◦ Was part of the University of Nicosia Artificial Intelligence Laboratory",
    ],
    icon: <img src={u_nicosia} alt="UNIC" className="h-12 w-12" />,
  },
];

export const experienceData = [
  {
    company: "Discover Financial Services, Chicago, United States",
    role: "Senior Data Science Analyst",
    dates: "Aug 2023 – April 2024",
    details: [
      "◦ Identified a critical false positive in fraud reason codes that was costing millions of dollars, leading to a  comprehensive analysis that refined fraud detection processes and significantly reduced erroneous financial losses.",
      "◦ Developed complex SQL queries within a CTE framework to simulate and analyze transactional data, significantly enhancing fraud detection capabilities by identifying patterns and establishing fraud metrics over rolling 30-day periods. This was done within the Snowflake environment.",
      "◦ Integrated and transformed diverse data sets within the Snowflake environment using advanced SQL techniques, including self-joins and cross-database joins, to enrich transactional insights, enabling detailed status tracking and behavioral analysis for strategic risk management.",
      "◦ Spearheaded the design and implementation of the 'EnhancedDriver' analytical tool using SQL within the Snowflake environment, improving data granularity and accuracy for fraud analysis, which supported proactive adjustments to fraud management protocols.",
      "◦ Successfully enhanced a watchlist screening algorithm for the Anti-Money Laundering Modeling and Analytics Team. The algorithm has a parsing stage and I reduced the runtime by 37% through the implementation of multithreading in Python. Processing time was cut from 2 hours to 1 hour 27 minutes.",
      "◦ Dramatically enhanced the pairing stage of the AML watchlist algorithm by 77% with the use of multithreading in Python. Operational runtime was reduced from 93 hours to 21.4 hours across various business lines.",
      "◦ Updated a C++ open-source package so that it can meet the requirements of the AML team.",
      "◦ Helped in pre-processing the watchlist profiles data of the AML team.",
    ],
    icon: <img src={discover} alt="discover" className="h-12 w-12" />,
  },
  {
    company: "Catalink Ltd, Nicosia, Cyprus",
    role: "Data Science Intern",
    dates: "February 2020 – April 2020",
    details: [
      "◦ Developed a machine learning model for pedestrian and vehicle detection and tracking using YOLO object detection, OpenCV and Python and the model achieved an accuracy of 90%. This was part of Europe’s Horizon 2020 Projects and it was a way of initiating the concept of Smart Cities in local areas.",
      "◦ Implemented a crises event detection machine learning model for detecting events like hurricanes and earthquakes using VGG16 so as to save the lives of thousands of people in time, with an accuracy of 81%. This was also part of Europe’s Horizon 2020 Projects and it was another way of initiating the concept of Smart Cities in local areas.",
    ],
    icon: <img src={catalink} alt="Catalink" className="h-12 w-12" />,
  },
  {
    company: "Twenty Third Century Systems Global, Harare, Zimbabwe",
    role: "SAP Financial Accounting Consultant Intern",
    dates: "April 2016 – September 2016",
    details: [
      "◦ Assisted in configuring a General Ledger and a House Bank that would record over 1000 business transactions and manage over 1000 incoming and outgoing transactions for a client using the SAP solution.",
    ],
    icon: <img src={ttcs} alt="ttcs" className="h-12 w-12" />,
  },
];

export const diplomasData = [
  {
    title: "Bachelor of Science in Computer Science Diploma",
    Image: bscCS,
    viewLink:
      "https://drive.google.com/file/d/1TlN7ADTmmhxF26QPHky-zok8JwLyYu6a/view?usp=sharing",
  },
  {
    title: "Master of Science in Computer Science Diploma",
    Image: mscCS,
    viewLink:
      "https://drive.google.com/file/d/1pZ69KdYQgcbexPD87PmMR7ytjkVAHMII/view?usp=sharing",
  },
  {
    title: "Master of Science in Finance Diploma",
    Image: mscFinance,
    viewLink:
      "https://drive.google.com/file/d/1fHf8EGPgOcjgqbbCoNZgjPVXSRzhrFhr/view?usp=sharing",
  },
  {
    title: "Tinotenda Nereus Certificate",
    Image: tinotendaCertificate,
    viewLink:
      "https://drive.google.com/file/d/1MSZ1TW0_ZjqByXewFLrVim4H_iZKG4Tz/view?usp=sharing",
  },
];

// src/data/data.js

export const genAIProjects = [
  {
    title: "Gemini Health App - AI-Powered Calorie Counter",
    description:
      "An AI-powered calorie counter using Google Gemini to estimate calories from uploaded food images.",
    image: food, // Update with a related image
    githubLink:
      "https://github.com/Tinzyl/Gemini-Health-App---AI-Powered-Calorie-Calculator",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Gemini-Health-App---AI-Powered-Calorie-Calculator/main/README.md",
    techStack: ["Streamlit", "Google Gemini", "Python", "PIL"],
  },
  {
    title: "YouTube Video Blog Content Creator",
    description:
      "Generates blog content from YouTube channel videos, leveraging AI agents and tools to streamline research and writing.",
    image: youtube, // Use a related image for the project
    githubLink: "https://github.com/Tinzyl/YouTube-Video-Blog-Content-Creator",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/YouTube-Video-Blog-Content-Creator/main/README.md",
    techStack: ["CrewAI", "Python", "YouTube API", "OpenAI GPT-4"],
  },
  {
    title: "YouTube Transcript to Detailed Notes Converter",
    description:
      "Converts YouTube video transcripts into detailed notes using Google Gemini and YouTube Transcript API.",
    image: youtube2, // Update this with a relevant image
    githubLink:
      "https://github.com/Tinzyl/YouTube-Transcript-to-Detailed-Notes-Converter",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/YouTube-Transcript-to-Detailed-Notes-Converter/main/README.md",
    techStack: [
      "Streamlit",
      "Python",
      "YouTube Transcript API",
      "Google Gemini",
    ],
  },
  {
    title: "Gemini LLM Q&A Application",
    description:
      "A question-answering app using the Gemini Pro model for natural language responses powered by Google Gemini.",
    image: qa, // Replace with an appropriate image
    githubLink: "https://github.com/Tinzyl/Gemini-LLM-Q-A-Application",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Gemini-LLM-Q-A-Application/main/README.md",
    techStack: ["Streamlit", "Python", "Google Gemini"],
  },
  {
    title: "Gemini Chat Application",
    description:
      "A real-time chat application using Google Gemini Pro, with interactive chat history support powered by Streamlit.",
    image: chat, // Replace with an appropriate image
    githubLink: "https://github.com/Tinzyl/Gemini-Chat-Application",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Gemini-Chat-Application/main/README.md",
    techStack: ["Streamlit", "Python", "Google Gemini"],
  },
  {
    title: "Gemini Image Analysis Application",
    description:
      "A Streamlit-based application that integrates Google Gemini 1.5 Flash for text and image processing. Users can upload an image, provide an optional text prompt, and receive a detailed AI-generated response combining insights from both.",
    image: comp, // Replace with an appropriate image
    githubLink: "https://github.com/Tinzyl/Gemini_Image_Analysis_Application-",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Gemini_Image_Analysis_Application-/main/README.md",
    techStack: ["Streamlit", "Python", "Google Gemini"],
  },
  {
    title: "Multi Language Invoice Extractor Application",
    description:
      "A Streamlit-based application that uses Google Gemini 1.5 Flash to analyze and extract insights from invoices.",
    image: invoice, // Replace with an appropriate image
    githubLink:
      "https://github.com/Tinzyl/Multi-Language-Invoice-Extractor-Using-Gemini-Vision",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Multi-Language-Invoice-Extractor-Using-Gemini-Vision/main/README.md",
    techStack: ["Streamlit", "Python", "Google Gemini"],
  },
  {
    title: "SQL Query Assistant Application",
    description:
      "A Streamlit-based application that uses Google Gemini 1.5 Flash to convert natural language queries into SQL commands. The SQL queries are executed on a SQLite database, and the results are displayed in real time.",
    image: sql, // Replace with an appropriate image
    githubLink:
      "https://github.com/Tinzyl/SQL-Query-Assistant-Using-Gemini-And-SQLite-",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/SQL-Query-Assistant-Using-Gemini-And-SQLite-/main/README.md",
    techStack: ["Streamlit", "SQL", "Python", "Google Gemini"],
  },
  {
    title: "Smart ATS AI-Powered Resume Evaluator",
    description:
      "A Streamlit-based application that uses Google Gemini 1.5 Flash to evaluate resumes against job descriptions. It acts as an intelligent Applicant Tracking System (ATS), providing a detailed analysis of resume strengths, weaknesses, and suggestions for improvement.",
    image: resume, // Replace with an appropriate image
    githubLink:
      "https://github.com/Tinzyl/Smart-ATS---AI-Powered-Resume-Evaluator",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Smart-ATS---AI-Powered-Resume-Evaluator/main/README.md",
    techStack: ["Streamlit", "Python", "Google Gemini"],
  },
  {
    title: "Document Query System with Vector Embeddings and Chat Models",
    description:
      "A document query system leveraging vector embeddings, OpenAI embeddings, and LangChain's ChatGroq for accurate document retrieval.",
    image: document, // Update with an appropriate image
    githubLink:
      "https://github.com/Tinzyl/Document-Query-System-with-Vector-Embeddings-and-Chat-Models",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Document-Query-System-with-Vector-Embeddings-and-Chat-Models/main/README.md",
    techStack: [
      "Streamlit",
      "Python",
      "langchain",
      "OpenAI GPT-4",
      "groq",
      "faiss",
      "pypdf",
    ],
  },
  {
    title: "LangChain: Summarize Text from YouTube or Websites",
    description:
      "An application using LangChain to summarize text from YouTube videos or web pages with Hugging Face models.",
    image: text, // Replace with an appropriate image
    githubLink:
      "https://github.com/Tinzyl/LangChain-Summarize-Text-from-YouTube-or-Websites",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/LangChain-Summarize-Text-from-YouTube-or-Websites/main/README.md",
    techStack: ["Streamlit", "langchain", "Python", "Hugging Face API", "groq"],
  },
  {
    title: "NVIDIA NIM Document Query System",
    description:
      "A document query system using NVIDIA AI endpoints, FAISS for vector search, and LangChain-powered pipelines.",
    image: nvidianim, // Replace with an appropriate image
    githubLink: "https://github.com/Tinzyl/NVIDIA-NIM-Document-Query-System",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/NVIDIA-NIM-Document-Query-System/main/README.md",
    techStack: [
      "Streamlit",
      "Python",
      "Nvidia AI Endpoints",
      "faiss",
      "pypdf",
      "langchain",
    ],
  },
  {
    title: "Neo4j Graph Query System with LangChain",
    description:
      "A graph query system leveraging Neo4j, LangChain, and OpenAI for semantic search and graph-based query capabilities.",
    image: graph, // Replace with a relevant image
    githubLink:
      "https://github.com/Tinzyl/Neo4j-Graph-Query-System-with-LangChain",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Neo4j-Graph-Query-System-with-LangChain/main/README.md",
    techStack: ["Streamlit", "Python", "Neo4j", "langchain", "OpenAI GPT-4"],
  },
  {
    title: "PDF Query System with LangChain and Astra DB",
    description:
      "A query system for PDFs powered by LangChain, Astra DB, and OpenAI for semantic search and contextual document querying.",
    image: query, // Replace with a relevant image
    githubLink:
      "https://github.com/Tinzyl/PDF-Query-System-with-LangChain-and-Astra-DB",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/PDF-Query-System-with-LangChain-and-Astra-DB/main/README.md",
    techStack: [
      "Streamlit",
      "Python",
      "Astra DB",
      "langchain",
      "OpenAI GPT-4",
      "pypdf",
    ],
  },
  {
    title: "Lamini Fine-Tuning Example",
    description:
      "A project demonstrating fine-tuning large language models using Lamini with custom datasets.",
    image: finetuning, // Replace with a relevant image
    githubLink: "https://github.com/Tinzyl/Lamini-Fine-Tuning-Example",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Lamini-Fine-Tuning-Example/main/README.md",
    techStack: ["Python", "Lamini", "OpenAI GPT-4"],
  },
];

export const deepLearningData = [
  {
    title: "Ethereum Price Prediction Using Long Short-Term Memory (LSTM)",
    description:
      "This project predicts the future price of Ethereum (ETH) using a Long Short-Term Memory (LSTM) neural network. The model is trained on historical price data to predict the price for the next hour.",
    image: ethereum, // Update with a related image
    githubLink:
      "https://github.com/Tinzyl/Ethereum-Price-Prediction-Using-Long-Short-Term-Memory-LSTM-",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Ethereum-Price-Prediction-Using-Long-Short-Term-Memory-LSTM-/main/README.md",
    techStack: [
      "Python",
      "Pandas",
      "Matplotlib",
      "Seaborn",
      "SkLearn",
      "Keras",
    ],
  },
  {
    title: "Deep Fake Detection Using CNNs",
    description:
      "This project leverages CNNs to detect DeepFake images by classifying images into Real or Fake. It uses a custom CNN model trained on a dataset of labeled images.",
    image: deepfake, // Update with a related image
    githubLink: "https://github.com/Tinzyl/DeepFake-Detection-Using-CNNs-",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/DeepFake-Detection-Using-CNNs-/main/README.md",
    techStack: [
      "Numpy",
      "Python",
      "Pandas",
      "Matplotlib",
      "Seaborn",
      "Tensorflow",
      "Keras",
    ],
  },
  {
    title: "Emotion Classification From Speech",
    description:
      "This project implements an emotion classification system that analyzes speech and identifies the emotion conveyed. The system uses the RAVDESS dataset and a Multi-Layer Perceptron (MLP) model for classification.",
    image: emotion, // Update with a related image
    githubLink: "https://github.com/Tinzyl/Emotion-Classification-From-Speech",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Emotion-Classification-From-Speech/main/README.md",
    techStack: ["Numpy", "Python", "Matplotlib", "SkLearn"],
  },
  {
    title: "Brain Tumour Detection Using CNNs",
    description:
      "This project implements a binary classification model using CNNs to detect brain tumors from grayscale MRI images. The model classifies images into Brain Tumor or Healthy categories.",
    image: brain, // Update with a related image
    githubLink:
      "https://github.com/Tinzyl/Brain-Tumor-Detection-Using-Convolutional-Neural-Networks-CNN-",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Brain-Tumor-Detection-Using-Convolutional-Neural-Networks-CNN-/main/README.md",
    techStack: [
      "Numpy",
      "Pandas",
      "Python",
      "Seaborn",
      "Matplotlib",
      "Keras",
      "Tensorflow",
    ],
  },
  {
    title: "COVID-19 Detection Using CNNs",
    description:
      "This project implements a deep learning model to classify chest X-ray images into COVID-19 or Non-COVID-19 categories using a Convolutional Neural Network (CNN).",
    image: covid19, // Update with a related image
    githubLink: "https://github.com/Tinzyl/Covid-19-Detection-Using-CNNs",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Covid-19-Detection-Using-CNNs/main/README.md",
    techStack: [
      "Numpy",
      "Pandas",
      "Python",
      "Seaborn",
      "Matplotlib",
      "Keras",
      "Tensorflow",
    ],
  },
  {
    title: "Age Gender Prediction Using Deep Learning",
    description:
      "This project implements a deep learning solution to predict age and gender from grayscale images using custom Convolutional Neural Networks (CNNs). The model achieves high accuracy for gender classification and competitive results for age prediction.",
    image: agegender, // Update with a related image
    githubLink:
      "https://github.com/Tinzyl/Age-and-Gender-Prediction-Using-Deep-Learning",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Age-and-Gender-Prediction-Using-Deep-Learning/main/README.md",
    techStack: ["Numpy", "Pandas", "Python", "Pil", "Matplotlib", "OpenCV"],
  },
  {
    title: "Number Plate Recognition Using Deep Learning",
    description:
      "This project implements a system for detecting and recognizing vehicle number plates from images using bounding box annotations and a custom CNN model. The system can identify license plates in images and extract textual information using Optical Character Recognition (OCR).",
    image: numberPlate, // Update with a related image
    githubLink:
      "https://github.com/Tinzyl/Number-Plate-Recognition-Using-Deep-Learning",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Number-Plate-Recognition-Using-Deep-Learning/main/README.md",
    techStack: [
      "Numpy",
      "Pandas",
      "Python",
      "Tensorflow",
      "Matplotlib",
      "SkLearn",
      "OpenCV",
      "Plotly",
      "PyTesseract",
    ],
  },
  {
    title: "Language Translation Using IBM Watson",
    description:
      "This project implements a system for detecting and recognizing vehicle number plates from images using bounding box annotations and a custom CNN model. The system can identify license plates in images and extract textual information using Optical Character Recognition (OCR).",
    image: language, // Update with a related image
    githubLink:
      "https://github.com/Tinzyl/Language-Translation-Using-IBM-Watson",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Language-Translation-Using-IBM-Watson/main/README.md",
    techStack: ["Python", "IBM Watson"],
  },
  {
    title: "Stress Detector",
    description:
      "This project uses Deep Learning to predict the stress level of individuals based on various heart rate variability features. The model is built using TensorFlow and Keras with a fully connected neural network.",
    image: stress, // Update with a related image
    githubLink: "https://github.com/Tinzyl/Stress-Level-Detection",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Stress-Level-Detection/main/README.md",
    techStack: [
      "Python",
      "Tensorflow",
      "Pandas",
      "Numpy",
      "SkLearn",
      "Matplotlib",
      "Keras",
    ],
  },
  {
    title: "Weed Detection",
    description:
      "This project leverages deep learning to classify images into four categories: broadleaf, grass, soil, and soybean. The model is built using TensorFlow and Keras",
    image: weed, // Update with a related image
    githubLink: "https://github.com/Tinzyl/Weed-Detection-Using-Deep-Learning-",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Weed-Detection-Using-Deep-Learning-/main/README.md",
    techStack: [
      "Python",
      "Tensorflow",
      "Pandas",
      "Matplotlib",
      "Keras",
      "Seaborn",
    ],
  },
];

export const machineLearningData = [
  {
    title: "Forecasting Renewable Energy Generation",
    description:
      "This project predicts wind turbine active power output using XGBoost, leveraging wind speed and temporal data as features. The dataset contains historical turbine performance data, including temperature, wind speed, and power generation metrics.",
    image: renewable, // Update with a related image
    githubLink:
      "https://github.com/Tinzyl/Wind-Turbine-Energy-Prediction-Using-XGBoost",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Wind-Turbine-Energy-Prediction-Using-XGBoost/main/README.md",
    techStack: [
      "Python",
      "Pandas",
      "Matplotlib",
      "Seaborn",
      "Numpy",
      "XGboost",
    ],
  },
  {
    title: "DNA Sequencing For Detecting E-Coli",
    description:
      "This project classifies DNA sequences as promoters or non-promoters to detect E. Coli. Using the UCI Promoter Gene Sequences dataset, the system implements machine learning techniques for binary classification with a focus on simplicity and accuracy.",
    image: dna, // Update with a related image
    githubLink: "https://github.com/Tinzyl/DNA-Sequencing-For-Detecting-E-Coli",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/DNA-Sequencing-For-Detecting-E-Coli/main/README.md",
    techStack: [
      "Python",
      "Pandas",
      "Matplotlib",
      "Seaborn",
      "Numpy",
      "SkLearn",
      "SVM",
    ],
  },
  {
    title: "Diamond Sales Prediction System",
    description:
      "A system that leverages machine learning to predict the total sales price of diamonds based on key attributes like carat weight, cut, clarity, and more.",
    image: diamond, // Update with a related image
    githubLink: "https://github.com/Tinzyl/Diamond-Sales-Prediction-System",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Diamond-Sales-Prediction-System/main/README.md",
    techStack: [
      "Python",
      "Pandas",
      "Matplotlib",
      "Seaborn",
      "RandomForest",
      "LinearRegression",
    ],
  },
  {
    title: "Spelling Corrector-NLP Powered Word Correction System",
    description:
      "Spelling Corrector is an NLP-based project that identifies misspelled words and suggests corrections using probabilistic methods. The tool is built on a foundation of natural language processing and dictionary-based approaches, ensuring robust and accurate word suggestions.",
    image: spell, // Update with a related image
    githubLink: "https://github.com/Tinzyl/Spelling-Corrector",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Spelling-Corrector/main/README.md",
    techStack: ["Python", "Pandas", "NLTK"],
  },
  {
    title: "Campus Placement Analyzer",
    description:
      "The Campus Placement Analyzer is a comprehensive project designed to analyze, visualize, and model campus placement data. The project identifies trends, predicts placement probabilities, and explores salary patterns for students across various academic and professional attributes.",
    image: education, // Update with a related image
    githubLink: "https://github.com/Tinzyl/Campus-Placement-Analyzer",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Campus-Placement-Analyzer/main/README.md",
    techStack: [
      "Python",
      "Pandas",
      "Numpy",
      "Seaborn",
      "Matplotlib",
      "Lasso Regreesion",
      "Ridge Regression",
      "Decision Tree",
    ],
  },
  {
    title: "Car Evaluation Classifier",
    description:
      "A lightweight Flask-based web application for predicting the quality of cars using multiple machine learning algorithms. Users can input car attributes, select an algorithm, and view results with detailed metrics and predictions.",
    image: car, // Update with a related image
    githubLink: "https://github.com/Tinzyl/Car-Evaluation-Classifier",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Car-Evaluation-Classifier/main/README.md",
    techStack: [
      "Python",
      "Flask",
      "SkLearn",
      "Logistic Regression",
      "SVM",
      "KNN",
      "RandomForest",
      "Decision Tree",
    ],
  },
  {
    title: "Generify-Predict-Book-Genres-With-AI",
    description:
      "Genreify is a machine learning project that predicts book genres based on their summaries. By leveraging text preprocessing and popular classification algorithms, Genreify provides accurate predictions and insights into the literary world.",
    image: books, // Update with a related image
    githubLink:
      "https://github.com/Tinzyl/Generify-Predict-Book-Genres-With-AI",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Generify-Predict-Book-Genres-With-AI/main/README.md",
    techStack: [
      "Python",
      "Pandas",
      "Matplotlib",
      "Seaborn",
      "Numpy",
      "NLTK",
      "SkLearn",
      "NaiveBayes",
      "SVM",
      "Decision Tree",
      "RandomForest",
    ],
  },
  {
    title: "Course Recommendation System",
    description:
      "A recommendation system for courses built using Udemy's course dataset. This system leverages natural language processing (NLP) techniques and similarity algorithms to suggest relevant courses based on user input.",
    image: course, // Update with a related image
    githubLink: "https://github.com/Tinzyl/Course-Recommendation-System",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Course-Recommendation-System/main/README.md",
    techStack: ["Python", "Pandas", "Seaborn", "Numpy", "SkLearn"],
  },
  {
    title: "Song Popularity Prediction",
    description:
      "A machine learning project that predicts whether a song will become popular based on various features.",
    image: songs, // Update with a related image
    githubLink: "https://github.com/Tinzyl/Song-Popularity-Prediction-",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Song-Popularity-Prediction-/main/README.md",
    techStack: ["Python", "Pandas", "Seaborn", "Numpy", "SkLearn"],
  },
  {
    title: "Medical Cost Predictions",
    description:
      "This project predicts medical insurance costs based on demographic and health-related features such as age, BMI, smoking status, and region.",
    image: medical, // Update with a related image
    githubLink: "https://github.com/Tinzyl/Medical_Cost_Predictions",
    readmeLink:
      "https://raw.githubusercontent.com/Tinzyl/Medical_Cost_Predictions/main/README.md",
    techStack: [
      "Python",
      "Pandas",
      "Seaborn",
      "Numpy",
      "SkLearn",
      "RandomForest",
    ],
  },
];

export const mLOpsData = [
  {
    title: "Network Security",
    description:
      "The networksecurity project is designed to detect phishing or fake websites by analyzing network data using machine learning. It encompasses data collection, preprocessing, model training, and validation components.",
    image: networksecurity, // Update with a related image
    githubLink: "https://github.com/Tinzyl/networksecurity",
    manualReadmeContent: `
      The networksecurity project is designed to detect phishing or fake websites by analyzing network data. It encompasses data collection, preprocessing, model training, and validation components.
      `,

    techStack: [
      "Python",
      "MLFLOW",
      "GIT",
      "GITHUB",
      "DAGSHUB",
      "DOCKER",
      "Matplotlib",
      "Seaborn",
      "Numpy",
      "KNN",
      "RandomForest",
    ],
  },
];

export const numericalData = [
  {
    title: "Finite Differences",
    description:
      "Approximates derivatives using finite difference methods(Forward, Backward, Central) while calculating relative errors to evaluate accuracy.",
    image: finitedifferences, // Update with a related image
    githubLink:
      "https://github.com/Tinzyl/Numerical-Analysis/blob/master/Finite_Differences.py",
    manualReadmeContent: `
      Finite Differences in Python.
      `,

    techStack: ["Python"],
  },
  {
    title: "Newton Method",
    description:
      "Uses Newton's Method to find the root of the equation x ** 2 − sin(x) = 0 iterating until convergence with a specified tolerance.",
    image: newtonmethod, // Update with a related image
    githubLink:
      "https://github.com/Tinzyl/Numerical-Analysis/blob/master/Newton_Method.py",
    manualReadmeContent: `
      Newton Method in Python.
      `,

    techStack: ["Python"],
  },
  {
    title: "Newton Raphson Method",
    description:
      "Applies Newton-Raphson's Method to find the root of the equation x ** 2 + cos ** 2(x) - 4x = 0, iterating until convergence with a specified tolerance.",
    image: newton, // Update with a related image
    githubLink:
      "https://github.com/Tinzyl/Numerical-Analysis/blob/master/Newton_Raphson.py",
    manualReadmeContent: `
      Newton Raphson Method in Python.
      `,

    techStack: ["Python"],
  },
  {
    title: "Simple Iterations",
    description:
      "Uses the Fixed-Point iteration method to find the root of the equation x = root(5x-3/2), iterating until convergence within a specified tolerance.",
    image: simpleiterations, // Update with a related image
    githubLink:
      "https://github.com/Tinzyl/Numerical-Analysis/blob/master/Simple_Iterations.py",
    manualReadmeContent: `
      Simple Iterations in Python.
      `,

    techStack: ["Python"],
  },
  {
    title: "Bisection Method",
    description:
      "Uses the Bisection Method to find the root of the equation 2x ** 2 - 5x + 3 = 0, iterating until convergence within a specified tolerance.",
    image: bisectionmethod, // Update with a related image
    githubLink:
      "https://github.com/Tinzyl/Numerical-Analysis/blob/master/bisection_method.py",
    manualReadmeContent: `
      Bisection Method in Python.
      `,

    techStack: ["Python"],
  },
  {
    title: "Gaussian Elimination",
    description:
      "Solves a system of linear equations using Gaussian Elimination with back-substitution, measuring computation time and saving the solution to a file.",
    image: gaussian, // Update with a related image
    githubLink:
      "https://github.com/Tinzyl/Numerical-Analysis/blob/master/linear_sys.py",
    manualReadmeContent: `
      Gaussian Elimination in Python.
      `,

    techStack: ["Python"],
  },
  {
    title: "Trapezoidal Rule",
    description:
      "Approximates the definite integral of c ** -x from 0 to 1 using the Trapezoidal Rule and Maclaurin Series Expansion, comparing results with the exact value from SciPy integration.",
    image: trapezoidal, // Update with a related image
    githubLink:
      "https://github.com/Tinzyl/Numerical-Analysis/blob/master/trapezoidal_rule.py",
    manualReadmeContent: `
      Trapezoidal Rule in Python.
      `,

    techStack: ["Python"],
  },
];
